module.exports = __webpack_public_path__ + "img/01ebeb75ba61479d9ec0d6d5f61d7dc2.2ea5b6ee.png";